import React from 'react';
import Dashboard from '../../../components/shared/dashboard/dashboard';
import MakeReservation from '../../../components/shared/make-reservation/make-reservation';
import { MakeReservationVariant } from '../../../components/shared/make-reservation/make-reservation.constants';
import { AllEventsPageStyled } from './all-events.page.styled';

const AllEventsPage = () => {

  return (
    <Dashboard callingPage={'AllEventsPage'}>
      <AllEventsPageStyled.Container>
        <MakeReservation variant={MakeReservationVariant.AdminAllEvents} />
      </AllEventsPageStyled.Container>
    </Dashboard>
  );
};

export default AllEventsPage;
